"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Units = exports.ConsumableTypes = exports.EquipmentTypes = void 0;
// Equipment Details
var EquipmentTypes;
(function (EquipmentTypes) {
    EquipmentTypes["Light"] = "LIGHT";
    EquipmentTypes["AC"] = "AC";
    EquipmentTypes["Fan"] = "FAN";
    EquipmentTypes["Dehumidifier"] = "DEHUMIDIFIER";
    EquipmentTypes["Site"] = "SITE";
    EquipmentTypes["Sensor"] = "SENSOR";
    EquipmentTypes["WaterTank"] = "TANK";
    EquipmentTypes["UserDefined"] = "EQUIP_USER_DEFINED";
})(EquipmentTypes = exports.EquipmentTypes || (exports.EquipmentTypes = {}));
// Consumable Details
var ConsumableTypes;
(function (ConsumableTypes) {
    ConsumableTypes["Nutrients"] = "NUTRIENTS";
    ConsumableTypes["Bulbs"] = "BULBS";
    ConsumableTypes["UserDefined"] = "CONSUME_USER_DEFINED";
})(ConsumableTypes = exports.ConsumableTypes || (exports.ConsumableTypes = {}));
var Units;
(function (Units) {
    Units["Single"] = "SINGLE";
    Units["Gallon"] = "GALLON";
    Units["Liter"] = "LITER";
    Units["Milliliter"] = "MILLILITER";
    Units["FluidOunce"] = "FLUID_OUNCE";
})(Units = exports.Units || (exports.Units = {}));
//# sourceMappingURL=inventoryInterfaces.js.map